<table class="table table-striped table-bordered" id="user-table">
    <caption data-ng-show="users" class="hidden ng-binding">Table of Realm Users</caption>
    <thead>
    <tr>
        <th colspan="8">
            <div class="form-inline">
                <div class="form-group">
                    <div class="input-group">
                        <input type="text" placeholder="Search..." data-ng-model="query.search" class="form-control search ng-pristine ng-valid ng-empty ng-touched" onkeydown="if (event.keyCode == 13) document.getElementById('userSearch').click()">
                        <div class="input-group-addon">
                                <i class="fa fa-search" id="userSearch" data-ng-click="firstPage()"></i>
                        </div>
                    </div>
                </div>
                <button id="viewAllUsers" class="btn btn-default ng-binding" ng-click="query.search = null; firstPage()">View all users</button>

                <div class="pull-right" data-ng-show="access.manageUsers">
                    <button data-ng-click="unlockUsers()" class="btn btn-default ng-binding">Unlock users</button>
                    
                    <a id="createUser" class="btn btn-default ng-binding" [routerLink]="['/addUser']" >Add user</a>
                </div>
            </div>
        </th>
    </tr>
    <tr>
    </tr><tr data-ng-show="searchLoaded &amp;&amp; users.length > 0" class="">
        <th class="w-15 ng-binding">ID</th>
        <th class="w-15 ng-binding">Username</th>
        <th class="w-15 ng-binding">Email</th>
        <th class="w-15 ng-binding">Last Name</th>
        <th class="w-15 ng-binding">First Name</th>
        <th colspan="3" class="ng-binding">Actions</th>
    </tr>
    </thead>
    <tfoot data-ng-show="users &amp;&amp; (users.length >= query.max || query.first > 0)" class="ng-hide">
    <tr>
        <td colspan="7">
            <div class="table-nav">
                <button data-ng-click="firstPage()" class="first ng-binding" ng-disabled="query.first == 0" disabled="disabled">First Page</button>
                <button data-ng-click="previousPage()" class="prev ng-binding" ng-disabled="query.first == 0" disabled="disabled">Previous Page</button>
                <button data-ng-click="nextPage()" class="next ng-binding" ng-disabled="users.length < query.max" disabled="disabled">Next Page</button>
            </div>
        </td>
    </tr>
    </tfoot>
    <tbody>
    <!-- ngRepeat: user in users --><tr ng-repeat="user in users" class="ng-scope">
        <td class="clip"><a href="#/realms/dental/users/e7107983-e94b-4004-b23b-2ab6b9472ae4" class="ng-binding">e7107983-e94b-4004-b23b-2ab6b9472ae4</a></td>
        <td class="clip ng-binding">app-user</td>
        <td class="clip ng-binding">test@test.com</td>
        <td class="clip ng-binding">Kargopolov</td>
        <td class="clip ng-binding">Sergey</td>
        <td class="kc-action-cell ng-binding" kc-open="/realms/dental/users/e7107983-e94b-4004-b23b-2ab6b9472ae4">Edit</td>
        <td data-ng-show="serverInfo.featureEnabled('IMPERSONATION') &amp;&amp; access.impersonation" class="kc-action-cell ng-binding" data-ng-click="impersonate(user.id)">Impersonate</td>
        <td data-ng-show="user.access.manage" class="kc-action-cell ng-binding" data-ng-click="removeUser(user)">Delete</td>
    </tr><!-- end ngRepeat: user in users --><tr ng-repeat="user in users" class="ng-scope">
               <tr data-ng-show="!users || users.length == 0" class="ng-hide">
        <td class="text-muted ng-binding ng-hide" data-ng-show="!users">Please enter a search, or click on view all users</td>
        <td class="text-muted ng-binding ng-hide" data-ng-show="searchLoaded &amp;&amp; users.length == 0 &amp;&amp; lastSearch != null">No results</td>
        <td class="text-muted ng-binding ng-hide" data-ng-show="searchLoaded &amp;&amp; users.length == 0 &amp;&amp; lastSearch == null">No users available</td>
    </tr>
    </tbody>
</table>